import _ from 'lodash';
import React from 'react';
import { AllocationBillableTypeFilter, AllocationBookingTypeFilter, YesNoFilter } from '~/components';
import { ClientFiltersBar, MemberFiltersBar, ProjectFiltersBar, ResourceFiltersBar } from '~/components/filters';
import FiltersBarContainer from '../../components/FiltersBar';

export default function FiltersBar({ params, onFilterChange }) {
  return (
    <FiltersBarContainer>
      <YesNoFilter
        icon="filter"
        placeholder="Only projects with allocations"
        value={params.onlyAllocatedProjects ? 'yes' : 'no'}
        onChange={({ target: { value } }) => onFilterChange({ onlyAllocatedProjects: value === 'yes' })}
      />

      <AllocationBookingTypeFilter
        value={params.allocationBookingTypeId}
        onChange={({ target: { value } }) => onFilterChange({ allocationBookingTypeId: value })}
      />

      <ClientFiltersBar filters={params} onChange={onFilterChange} />

      <ProjectFiltersBar filters={params} onChange={onFilterChange} />

      <MemberFiltersBar filters={params} onChange={onFilterChange} />

      <ResourceFiltersBar filters={params} onChange={onFilterChange} />

      {!_.isEmpty(params.allocationBillableTypes) && (
        <AllocationBillableTypeFilter
          value={params.allocationBillableTypes}
          onChange={({ target: { value } }) => onFilterChange({ allocationBillableTypes: value })}
        />
      )}
    </FiltersBarContainer>
  );
}
